<div fxLayout="row" fxLayoutAlign="center center" *ngIf="!isOnLine" >
  <mat-icon color="warn" aria-hidden="true" fxFlex="0 0 24px">error</mat-icon>
  <span fxFlex="1 1 80" i18n="network-state|Warning; lost network@@network-state_warning_lost-network">You have lost connection to the internet.<br />This app is offline.</span>
</div>


